import React from "react";
import { Tag, Tooltip } from "antd";

export const newApps = (leng, ind) => {
  return [
    {
      title: () => {
        return (
          <>
            App Name <Tag color="processing">{leng}</Tag>
          </>
        );
      },
      dataIndex: "new_app_name",
      key: "new_app_name",
      fixed: "left",
      sorter: (a, b) =>
        a.new_app_name ? a.new_app_name.localeCompare(b.new_app_name) : 1,
      responsive: ["sm"],
      width: "35%",
    },
    {
      title: "Category Name",
      dataIndex: "current_category",
      key: "current_category",
      fixed: "left",
      sorter: (a, b) =>
        a.current_category
          ? a.current_category.localeCompare(b.current_category)
          : 1,
      responsive: ["sm"],
      width: "35%",
    },
    {
      title: () => {
        return (
          <Tooltip placement="left" title={"Cloud Confidence Level"}>
            CCL
          </Tooltip>
        );
      },
      dataIndex: "current_ccl",
      key: "current_ccl",
      fixed: "left",
      sorter: (a, b) =>
        a.current_ccl ? a.current_ccl.localeCompare(b.current_ccl) : 1,
      responsive: ["sm"],
      width: "15%",
    },
    {
      title: ind,
      dataIndex: "scheduled_date",
      key: "scheduled_date",
      fixed: "left",
      width: "15%",
      defaultSortOrder: "descend",
      sorter: (a, b) => new Date(a.scheduled_date) - new Date(b.scheduled_date),
      render: (text, record) => {
        return <>{text !== null ? text : ""}</>;
      },
    },
  ];
};

export const chngCclApps = (leng, ind) => {
  return [
    {
      title: () => {
        return (
          <>
            App Name <Tag color="processing">{leng}</Tag>
          </>
        );
      },
      dataIndex: "new_app_name",
      key: "new_app_name",
      fixed: "left",
      sorter: (a, b) =>
        a.new_app_name ? a.new_app_name.localeCompare(b.new_app_name) : 1,
      responsive: ["sm"],
      width: "35%",
    },
    {
      title: "Category Name",
      dataIndex: "current_category",
      key: "current_category",
      fixed: "left",
      sorter: (a, b) =>
        a.current_category
          ? a.current_category.localeCompare(b.current_category)
          : 1,
      responsive: ["sm"],
      width: "35%",
    },
    {
      title: () => {
        return (
          <Tooltip placement="left" title={" Old Cloud Confidence Level"}>
            Old CCL
          </Tooltip>
        );
      },
      dataIndex: "old_ccl",
      key: "old_ccl",
      fixed: "left",
      sorter: (a, b) => (a.old_ccl ? a.old_ccl.localeCompare(b.old_ccl) : 1),
      responsive: ["sm"],
      width: "15%",
    },
    {
      title: () => {
        return (
          <Tooltip placement="left" title={" New Cloud Confidence Level"}>
            New CCL
          </Tooltip>
        );
      },
      dataIndex: "current_ccl",
      key: "current_ccl",
      fixed: "left",
      sorter: (a, b) =>
        a.current_ccl ? a.current_ccl.localeCompare(b.current_ccl) : 1,
      responsive: ["sm"],
      width: "15%",
    },
    {
      title: ind,
      dataIndex: "scheduled_date",
      key: "scheduled_date",
      fixed: "left",
      width: "15%",
      defaultSortOrder: "descend",
      sorter: (a, b) => new Date(a.scheduled_date) - new Date(b.scheduled_date),
      render: (text, record) => {
        return <>{text !== null ? text : ""}</>;
      },
    },
  ];
};

export const newDomain = (leng, ind) => {
  return [
    {
      title: () => {
        return (
          <>
            App Name <Tag color="processing">{leng}</Tag>
          </>
        );
      },
      dataIndex: "new_app_name",
      key: "new_app_name",
      fixed: "left",
      sorter: (a, b) =>
        a.new_app_name ? a.new_app_name.localeCompare(b.new_app_name) : 1,
      responsive: ["sm"],
      width: "35%",
    },
    {
      title: "Category Name",
      dataIndex: "current_category",
      key: "current_category",
      fixed: "left",
      sorter: (a, b) =>
        a.current_category
          ? a.current_category.localeCompare(b.current_category)
          : 1,
      responsive: ["sm"],
      width: "35%",
    },
    {
      title: "Domain",
      dataIndex: "new_domain",
      key: "new_domain",
      fixed: "left",
      sorter: (a, b) =>
        a.new_domain ? a.new_domain.localeCompare(b.new_domain) : 1,
      responsive: ["sm"],
      width: "15%",
    },
    {
      title: ind,
      dataIndex: "scheduled_date",
      key: "scheduled_date",
      fixed: "left",
      width: "15%",
      defaultSortOrder: "descend",
      sorter: (a, b) => new Date(a.scheduled_date) - new Date(b.scheduled_date),
      render: (text, record) => {
        return <>{text !== null ? text : ""}</>;
      },
    },
  ];
};

export const catChngApps = (leng, ind) => {
  return [
    {
      title: () => {
        return (
          <>
            App Name <Tag color="processing">{leng}</Tag>
          </>
        );
      },
      dataIndex: "new_app_name",
      key: "new_app_name",
      fixed: "left",
      sorter: (a, b) =>
        a.new_app_name ? a.new_app_name.localeCompare(b.new_app_name) : 1,
      width: "25%",
    },
    {
      title: "Old Category",
      dataIndex: "old_category",
      key: "old_category",
      fixed: "left",
      sorter: (a, b) =>
        a.old_category ? a.old_category.localeCompare(b.old_category) : 1,
      responsive: ["sm"],
      width: "25%",
    },
    {
      title: "Current Category",
      dataIndex: "current_category",
      key: "current_category",
      fixed: "left",
      sorter: (a, b) =>
        a.current_category
          ? a.current_category.localeCompare(b.current_category)
          : 1,
      responsive: ["sm"],
      width: "15%",
    },
    {
      title: ind,
      dataIndex: "scheduled_date",
      key: "scheduled_date",
      fixed: "left",
      width: "15%",
      defaultSortOrder: "descend",
      sorter: (a, b) => new Date(a.scheduled_date) - new Date(b.scheduled_date),
      render: (text, record) => {
        return <>{text !== null ? text : ""}</>;
      },
    },
  ];
};

export const nameChngApps = (leng, ind) => {
  return [
    {
      title: () => {
        return (
          <>
            Old App Name <Tag color="processing">{leng}</Tag>
          </>
        );
      },
      dataIndex: "old_app_name",
      key: "old_app_name",
      fixed: "left",
      sorter: (a, b) =>
        a.old_app_name ? a.old_app_name.localeCompare(b.old_app_name) : 1,
      responsive: ["sm"],
      width: "25%",
    },
    {
      title: "New App Name",
      dataIndex: "new_app_name",
      key: "new_app_name",
      fixed: "left",
      sorter: (a, b) =>
        a.new_app_name ? a.new_app_name.localeCompare(b.new_app_name) : 1,
      responsive: ["sm"],
      width: "25%",
    },
    {
      title: ind,
      dataIndex: "scheduled_date",
      key: "scheduled_date",
      fixed: "left",
      width: "15%",
      defaultSortOrder: "descend",
      sorter: (a, b) => new Date(a.scheduled_date) - new Date(b.scheduled_date),
      render: (text, record) => {
        return <>{text !== null ? text : ""}</>;
      },
    },
  ];
};

export const breachedApps = (leng, ind) => {
  return [
    {
      title: () => {
        return (
          <>
            App Name <Tag color="processing">{leng}</Tag>
          </>
        );
      },
      dataIndex: "new_app_name",
      key: "new_app_name",
      fixed: "left",
      sorter: (a, b) =>
        a.new_app_name ? a.new_app_name.localeCompare(b.new_app_name) : 1,
      responsive: ["sm"],
      width: "25%",
    },
    {
      title: "Category Name",
      dataIndex: "current_category",
      key: "current_category",
      fixed: "left",
      sorter: (a, b) =>
        a.current_category
          ? a.current_category.localeCompare(b.current_category)
          : 1,
      responsive: ["sm"],
      width: "35%",
    },
    {
      title: "Breached Date",
      dataIndex: "breached_date",
      key: "breached_date",
      fixed: "left",
      width: "15%",
      sorter: (a, b) => new Date(a.breached_date) - new Date(b.breached_date),
      render: (text, record) => {
        return <>{text !== null ? text : ""}</>;
      },
    },
    {
      title: ind,
      dataIndex: "scheduled_date",
      key: "scheduled_date",
      fixed: "left",
      width: "15%",
      defaultSortOrder: "descend",
      sorter: (a, b) => new Date(a.scheduled_date) - new Date(b.scheduled_date),
      render: (text, record) => {
        return <>{text !== null ? text : ""}</>;
      },
    },
  ];
};

// Unified "Domain Changes" columns: shows new-domain and remapped-domain rows
// in a single table, distinguished by the Type column. Domain is sourced from
// new_domain for both types (that is where the value lives).
export const domainChanges = (leng, ind) => {
  return [
    {
      title: () => (
        <>
          App Name <Tag color="processing">{leng}</Tag>
        </>
      ),
      dataIndex: "new_app_name",
      key: "new_app_name",
      fixed: "left",
      sorter: (a, b) =>
        a.new_app_name ? a.new_app_name.localeCompare(b.new_app_name) : 1,
      responsive: ["sm"],
      width: "22%",
    },
    {
      title: "Type",
      dataIndex: "change_type",
      key: "change_type",
      sorter: (a, b) =>
        a.change_type ? a.change_type.localeCompare(b.change_type) : 1,
      responsive: ["sm"],
      width: "16%",
      render: (text) => {
        const color = text === "Remapped Domain" ? "orange" : "blue";
        return text ? <Tag color={color}>{text}</Tag> : "";
      },
    },
    {
      title: "Old Category",
      dataIndex: "old_category",
      key: "old_category",
      sorter: (a, b) =>
        a.old_category ? a.old_category.localeCompare(b.old_category) : 1,
      responsive: ["sm"],
      width: "18%",
    },
    {
      title: "New Category",
      dataIndex: "current_category",
      key: "current_category",
      sorter: (a, b) =>
        a.current_category
          ? a.current_category.localeCompare(b.current_category)
          : 1,
      responsive: ["sm"],
      width: "18%",
    },
    {
      title: "Domain",
      dataIndex: "new_domain",
      key: "new_domain",
      sorter: (a, b) =>
        a.new_domain ? a.new_domain.localeCompare(b.new_domain) : 1,
      responsive: ["sm"],
      width: "14%",
    },
    {
      title: ind,
      dataIndex: "scheduled_date",
      key: "scheduled_date",
      width: "12%",
      defaultSortOrder: "descend",
      sorter: (a, b) => new Date(a.scheduled_date) - new Date(b.scheduled_date),
      render: (text, record) => {
        return <>{text !== null ? text : ""}</>;
      },
    },
  ];
};

export const getJs = (rel, prev, sel) => {
  switch (sel) {
    case "new_apps":
      return {
        type: "fetch",
        qry: "fetNewCciApps",
        firstVal: "snapshot_v" + rel + "_0_0",
        secondVal: "snapshot_v" + rel + "_0_0",
        thirdVal: "snapshot_v" + rel + "_0_0",
        fourthVal: "snapshot_v" + rel + "_0_0",
        fifthVal: "snapshot_v" + prev + "_0_0",
      };
    case "new_domains":
      return {
        type: "fetch",
        qry: "fetNewDomain",
        firstVal: "snapshot_v" + rel + "_0_0",
        secondVal: "snapshot_v" + rel + "_0_0",
        thirdVal: "snapshot_v" + rel + "_0_0",
        fourthVal: "snapshot_v" + rel + "_0_0",
        fifthVal: "snapshot_v" + prev + "_0_0",
      };
    case "changed_ccl_apps":
      return {
        type: "fetch",
        qry: "fetChngCclApps",
        firstVal: "snapshot_v" + rel + "_0_0",
        secondVal: "snapshot_v" + rel + "_0_0",
        thirdVal: "snapshot_v" + rel + "_0_0",
        fourthVal: "snapshot_v" + rel + "_0_0",
        fifthVal: "snapshot_v" + prev + "_0_0",
        sixthVal: "snapshot_v" + prev + "_0_0",
        seventhVal: "snapshot_v" + prev + "_0_0",
        eigthVal: "snapshot_v" + prev + "_0_0",
      };
    case "category_changed_apps":
      return {
        type: "fetch",
        qry: "fetCciAppCatUpdate",
        firstVal: "snapshot_v" + rel + "_0_0",
        secondVal: "snapshot_v" + rel + "_0_0",
        thirdVal: "snapshot_v" + rel + "_0_0",
        fourthVal: "snapshot_v" + prev + "_0_0",
        fifthVal: "snapshot_v" + prev + "_0_0",
      };
    case "name_changed_apps":
      return {
        type: "fetch",
        qry: "fetCciChngAppName",
        firstVal: "snapshot_v" + rel + "_0_0",
        secondVal: "snapshot_v" + prev + "_0_0",
      };
    case "breached_apps":
      return {
        type: "fetch",
        qry: "fetCciChngAppName",
        firstVal: "snapshot_v" + rel + "_0_0",
        secondVal: "snapshot_v" + prev + "_0_0",
      };

    default:
      console.log(`Sorry, we are out of ${sel}.`);
  }
};

export const tabPageCss = {
  padding: "0",
  marginBottom: "0",
};

export const cardCss = { padding: "0", borderStyle: "hidden" };
